import { ReactNode } from "react";

export interface OverviewStatItem {
  key: string;
  label: string;
  value: number;
  icon: ReactNode;
  color: string;
}

const OverviewStatStrip = ({ items }: { items: OverviewStatItem[] }) => {
  return (
    <div className="flex flex-col rounded-xl border border-[#E4EAF0] bg-[#F0FAF9] sm:flex-row sm:divide-x sm:divide-[#E4EAF0] divide-y divide-[#E4EAF0] sm:divide-y-0">
      {items.map((item) => (
        <div
          key={item.key}
          className="flex flex-1 flex-col items-center justify-center gap-2 px-4 py-4 text-center"
        >
          <span
            className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider"
            style={{ color: item.color }}
          >
            <span aria-hidden="true" className="flex items-center">
              {item.icon}
            </span>
            {item.label}
          </span>
          <span className="text-[26px] font-extrabold leading-none text-[#10253A]">
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default OverviewStatStrip;